import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

// 입찰 모달 — 만원 단위 입력 → 원 단위로 POST
function AuctionBidModal(props){
  var auction=props.auction||{};
  var myStatus=props.myStatus||{};
  var onClose=props.onClose;
  var onSuccess=props.onSuccess;

  var myCurrentAmount=myStatus.myAmount||0;
  var isEdit=!!myStatus.hasBid;

  var minMan=isEdit?Math.round(myCurrentAmount/10000)+1:1;
  var defaultMan=isEdit?Math.max(minMan,Math.round(myCurrentAmount/10000)+10):1;

  var[amountMan,setAmountMan]=useState(String(defaultMan));
  var[memo,setMemo]=useState('');
  var[submitting,setSubmitting]=useState(false);
  var[error,setError]=useState('');
  var[confirming,setConfirming]=useState(false);

  useEffect(function(){
    // auction 변경 시 기본값 재계산 (모달 재오픈 대비)
    setAmountMan(String(defaultMan));
    setMemo(isEdit?(myStatus.memo||''):'');
    setError('');
    setConfirming(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auction.id]);

  var parsed=parseInt(String(amountMan).replace(/,/g,''))||0;
  var amountWon=parsed*10000;
  var isValid=parsed>=minMan;

  var formatMan=function(n){
    if(!n&&n!==0)return '';
    return Number(n).toLocaleString();
  };

  var handleInputChange=function(e){
    var v=e.target.value.replace(/[^0-9,]/g,'').replace(/,/g,'');
    setAmountMan(v);
    setError('');
  };

  var handleStep=function(delta){
    var next=Math.max(minMan,parsed+delta);
    setAmountMan(String(next));
    setError('');
  };

  var handleConfirm=function(){
    if(!isValid){
      setError('최소 '+formatMan(minMan)+'만원 이상 입력해주세요');
      return;
    }
    setConfirming(true);
  };

  var handleSubmit=function(){
    if(submitting)return;
    setSubmitting(true);
    setError('');
    authFetch(API+'/auctions/'+auction.id+'/bid',{
      method:'POST',
      body:JSON.stringify({amount:amountWon,memo:memo})
    })
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          if(onSuccess)onSuccess(d.data);
        }else{
          setError((d&&d.error)||'입찰 실패');
          setConfirming(false);
        }
      })
      .catch(function(){setError('서버 연결 실패');setConfirming(false)})
      .then(function(){setSubmitting(false)});
  };

  var modelLabel=(auction.car&&auction.car.model)||auction.title||'경매 차량';
  var yearLabel=auction.car&&auction.car.year?auction.car.year+' ':'';

  return (
    <div onClick={onClose}
      style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
      <div onClick={function(e){e.stopPropagation()}}
        style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:440,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>

        {/* 헤더 */}
        <div style={{padding:'16px 20px',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1B3A5C'}}>{isEdit?'💰 입찰 수정':'💰 입찰하기'}</div>
          <button onClick={onClose}
            style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#94a3b8',padding:4}}>✕</button>
        </div>

        {/* 본문 */}
        <div style={{padding:'18px 20px'}}>
          {/* 차량 요약 */}
          <div style={{fontSize:14,fontWeight:700,color:'#0f172a',marginBottom:4}}>{yearLabel}{modelLabel}</div>
          <div style={{fontSize:12,color:'#64748b',marginBottom:16}}>
            최소 입찰 1만원 · 자유 입찰
          </div>

          {/* 기존 입찰 표시 */}
          {isEdit&&(
            <div style={{padding:'10px 12px',background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:8,marginBottom:14,fontSize:12,color:'#1e40af'}}>
              내 기존 입찰: <strong>{formatMan(myCurrentAmount/10000)}만원</strong>
              {myStatus.myRank>0&&<span> (현재 {myStatus.myRank}위)</span>}
            </div>
          )}

          {/* 금액 입력 */}
          <div style={{marginBottom:10}}>
            <div style={{fontSize:11,color:'#64748b',marginBottom:6,fontWeight:600}}>입찰 금액 (만원)</div>
            <div style={{display:'flex',alignItems:'center',gap:6}}>
              <button onClick={function(){handleStep(-10)}} disabled={submitting||confirming}
                style={{width:36,height:44,borderRadius:8,border:'1px solid #cbd5e1',background:'#f8fafc',fontSize:16,fontWeight:700,color:'#475569',cursor:'pointer'}}>−</button>
              <input type="text" inputMode="numeric"
                value={formatMan(parsed)}
                onChange={handleInputChange}
                disabled={submitting||confirming}
                style={{flex:1,padding:'10px 12px',border:'2px solid #1B3A5C',borderRadius:8,fontSize:18,fontWeight:700,textAlign:'right',color:'#0f172a',outline:'none'}}/>
              <div style={{fontSize:13,fontWeight:700,color:'#475569'}}>만원</div>
              <button onClick={function(){handleStep(10)}} disabled={submitting||confirming}
                style={{width:36,height:44,borderRadius:8,border:'1px solid #cbd5e1',background:'#f8fafc',fontSize:16,fontWeight:700,color:'#475569',cursor:'pointer'}}>+</button>
            </div>
            <div style={{fontSize:11,color:parsed>=minMan?'#10b981':'#ef4444',marginTop:6}}>
              최소 {formatMan(minMan)}만원 이상
            </div>
          </div>

          {/* 빠른 증액 */}
          <div style={{display:'flex',gap:6,marginBottom:16}}>
            {[1,5,10,100].map(function(inc){
              return (
                <button key={inc} onClick={function(){handleStep(inc)}} disabled={submitting||confirming}
                  style={{flex:1,padding:'6px 0',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:6,fontSize:11,fontWeight:600,color:'#475569',cursor:'pointer'}}>
                  +{inc}만
                </button>
              );
            })}
          </div>

          {/* 메모 */}
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,color:'#64748b',marginBottom:6,fontWeight:600}}>메모 (선택)</div>
            <textarea value={memo} onChange={function(e){setMemo(e.target.value.substring(0,500))}}
              disabled={submitting||confirming}
              placeholder="출품자에게 전할 말 (500자 이내)"
              style={{width:'100%',minHeight:60,padding:'8px 10px',border:'1px solid #cbd5e1',borderRadius:6,fontSize:12,resize:'vertical',fontFamily:'inherit',outline:'none',boxSizing:'border-box'}}/>
          </div>

          {/* 안내 */}
          <div style={{padding:'10px 12px',background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:8,marginBottom:14,fontSize:11,color:'#9a3412',lineHeight:1.6}}>
            ⚠ 입찰 후 하향 수정 불가 · 입찰은 구매 의사를 나타냅니다
          </div>

          {/* 에러 */}
          {error&&(
            <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,marginBottom:14,fontSize:12,color:'#dc2626'}}>
              {error}
            </div>
          )}

          {/* 확인 단계 */}
          {confirming?(
            <div>
              <div style={{padding:'14px',background:'#eff6ff',border:'2px solid #1B3A5C',borderRadius:8,marginBottom:12,textAlign:'center'}}>
                <div style={{fontSize:12,color:'#64748b',marginBottom:4}}>입찰 금액</div>
                <div style={{fontSize:22,fontWeight:800,color:'#1B3A5C'}}>{formatMan(parsed)}만원</div>
                <div style={{fontSize:11,color:'#64748b',marginTop:4}}>({formatMan(amountWon)}원)</div>
              </div>
              <div style={{display:'flex',gap:8}}>
                <button onClick={function(){setConfirming(false);setError('')}} disabled={submitting}
                  style={{flex:1,padding:'12px 0',background:'#f1f5f9',border:'1px solid #cbd5e1',borderRadius:8,fontSize:13,fontWeight:700,color:'#475569',cursor:submitting?'wait':'pointer'}}>
                  다시
                </button>
                <button onClick={handleSubmit} disabled={submitting}
                  style={{flex:2,padding:'12px 0',background:submitting?'#94a3b8':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:800,cursor:submitting?'wait':'pointer'}}>
                  {submitting?'처리 중...':'✓ 최종 입찰'}
                </button>
              </div>
            </div>
          ):(
            <button onClick={handleConfirm} disabled={!isValid||submitting}
              style={{width:'100%',padding:'13px 0',background:(!isValid||submitting)?'#cbd5e1':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:(!isValid||submitting)?'not-allowed':'pointer'}}>
              {isEdit?'입찰 수정하기':'입찰 확인'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuctionBidModal;
